import React from 'react'
import { observer } from 'mobx-react'
import useResponsive from '@hooks/useResponsive'
import Legends from '@ui/Legends'
import Responsive from './Responsive'
import Desktop from './Desktop'

function MultipleRating(props) {
  const isResponsive = useResponsive(1137)

  return isResponsive || props.mode === 'mobile' ? (
    <Responsive {...props} />
  ) : (
    <>
      <Desktop {...props} />
      {props.legends && <Legends list={props.legends} className='mb-16' />}
    </>
  )
}

export default observer(MultipleRating)
